"use strict";

/**
 * Предоставляет инструменты для работы с EDMS-объектами через Агент веб-доступа.
 *
 * @namespace WebAccess.agent.edms
 * @since 5.0.0.4100
 */
(function (global) {

  var edms = {
    /**
     * Проверяет наличие локальных копий документов.
     * Если локальные копии документов найдены, отобразится окно с полным списком копий.
     *
     * @method WebAccess.agent.edms.checkDocumentLocalCopies
     * @return {WebAccess.agent.edms} Объект типа edms.
     */
    checkDocumentLocalCopies: function () {
      //FIXME: always переделать на done и fail
      global.isPluginAvailable("edmsplugin").always(function (isAvailableResponse) {
        if (isAvailableResponse) {
          global.transmitRequest("CheckDocumentLocalCopies", "edmsPlugin", {}).done(function (response) {
            var localCopies = response.result;
            if (localCopies.length > 0) {
              ShowLocalCopiesWindow($.toJSON(localCopies));
            }
          }).fail(function (response) {
            ShowError(response.message);
          });
        }
      });
      return global;
    },

    /**
     * Получает список редактируемых документов.
     *
     * @method WebAccess.agent.edms.getOpenedDocuments
     * @return {Deferred<Object>} Результат запроса.
     * @see https://api.jquery.com/category/deferred-object/
     */
    getOpenedDocuments: function () {
      var def = $.Deferred();
      global.isPluginAvailable("edmsplugin").done(function (isAvailable) {
        if (isAvailable) {
          global.transmitRequest("CHECKOPENEDDOCUMENTS", "edmsPlugin", {}).done(function (response) {
            var docs = response.result;
            def.resolve(docs);
          }).fail(function (response) {
            def.reject(response.message);
          });
        } else {
          def.reject();
        }
      }).fail(function () {
        def.reject();
      });

      return def;
    },

    /**
     * Проверяет наличие локальной копии документа с указанным ИД.
     *
     * @method WebAccess.agent.edms.checkDocumentHasLocalCopy
     * @param {int} docID ИД документа, у которого нужно проверить наличие локальных копий
     * @return {Deferred<Array<Object>>} Массив с локальными копиями указанного документа.
     * @see https://api.jquery.com/category/deferred-object/
     */
    checkDocumentHasLocalCopy: function (docID) {
      var d = $.Deferred();

      //FIXME: always переделать на done и fail
      global.isPluginAvailable("edmsplugin")
        .always(function (isAvailableResponse) {
          if (isAvailableResponse) {
            global.transmitRequest("CheckDocumentLocalCopies", "edmsPlugin", {}).done(function (response) {
              var localCopies = !!response.result ? response.result : [];
              var res = [];
              if (localCopies.length > 0) {
                for (var i = 0; i < localCopies.length; i++) {
                  if (localCopies[i].ID == docID) {
                    res.push(localCopies[i]);
                  }
                }
              }
              d.resolve(res);
            }).fail(function (response) {
              d.reject([]);
            });
          } else {
            d.reject([]);
          }
        });
      return d.promise();
    },

    /**
     * Подписывает документ указанным сертификатом.
     *
     * @method WebAccess.agent.edms.signDocument
     * @param  {number} docId              ИД документа для подписания
     * @param  {number} versionNumber      Номер версии документа для подписания
     * @param  {number} certificateId      ИД сертификата, которым будет подписан документ
     * @param  {string} pluginName   Имя плагина Агента веб-доступа для подписания
     * @param  {string} comment            Комментарий к подписи
     * @param  {boolean} isApprovingSign    Признак утверждающей подписи
     * @param  {boolean} isForSubstitute    Признак подписания документа от имени замещаемого пользователя
     * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
     * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {string} additionalInfo   Дополнительная информация о подписании документа
     * @param  {string} pluginVersion   Версия плагина Агента веб-доступа для подписания
     * @param  {string} tokenPinCode   Пин-код токена, с помощью которого подписывается документ
     * @return {Deferred<WebAccess.agent.edms>} Объект типа edms.
     * @see https://api.jquery.com/category/deferred-object/
     */
    signDocument: function (docId, versionNumber, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode) {
      var me = this;
      var d = $.Deferred();
      RequestToken(TOKEN_OPERATION.SIGN_DOCUMENT | TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
        var requestParams = {
          "DocumentID": docId,
          "DocumentVersion": versionNumber,
          "Token": token,
          "AdditionalInfo": additionalInfo,
          "PluginVersion": typeof pluginVersion == 'undefined' ? null : pluginVersion,
          "TokenPinCode": typeof tokenPinCode == 'undefined' ? null : tokenPinCode
        };
        me._signObject("SignDocumentVersion", requestParams, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback)
          .done((res) => {
            d.resolve(res);
          }).fail((res) => {
          d.reject(res);
        });
      }, docId, versionNumber);
      return d.promise();
    },

    /**
     * Подписывает атрибуты указанным RSA-сертификатом.
     *
     * @method WebAccess.agent.edms.signAttributes
     * @param  {string} attributes       Набор атрибутов для подписания
     * @param  {number} certificateId       ИД сертификата, которым будут подписаны атрибуты
     * @param  {string} pluginName Имя плагина Агента веб-доступа для подписания
     * @param  {string} pluginVersion    Версия плагина Агента веб-доступа для подписания
     * @param  {string} comment          Комментарий к подписи
     * @param  {boolean} isApprovingSign    Признак утверждающей подписи
     * @param  {boolean} isForSubstitute    Признак подписания документа от имени замещаемого пользователя
     * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
     * @param  {string} additionalInfo  Дополнительная информация
     * @param  {string} tokenPinCode  Пин-код токена, с помощью которого подписываются атрибуты
     * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
     * @return {Deferred<WebAccess.agent.edms>} Объект типа edms.
     * @see https://api.jquery.com/category/deferred-object/
     */
    signAttributes: function (attributes, certificateId, pluginName, pluginVersion, comment, isApprovingSign, isForSubstitute, substituteUserCode, additionalInfo, tokenPinCode, onSignedCallback) {
      var me = this;
      var d = $.Deferred();

      var requestParams = {
        "Attributes": attributes,
        "AdditionalInfo": additionalInfo,
        "PluginVersion": typeof pluginVersion == 'undefined' ? null : btoa(pluginVersion),  //агент ожидает получить версию плагина подписания в base64
        "TokenPinCode": typeof tokenPinCode == 'undefined' ? null : tokenPinCode
      };
      me._signObject("SignAttributes", requestParams, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback).done(function (res) {
        d.resolve(res);
      }).fail(function (res) {
        d.reject(res);
      });

      return d.promise();
    },

    /**
     * Подписывает текст задания.
     *
     * @method WebAccess.agent.edms.signJob
     * @param  {number} jobId              ИД задания для подписания
     * @param  {number} certificateId      ИД сертификата, которым будет подписан текст задания
     * @param  {string} pluginName   Имя плагина Агента веб-доступа для подписания
     * @param  {string} comment            Комментарий к подписи
     * @param  {boolean} isApprovingSign    Признак утверждающей подписи
     * @param  {boolean} isForSubstitute    Признак подписания текста от имени замещаемого пользователя
     * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
     * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {string} pluginVersion   Версия плагина Агента веб-доступа для подписания
     * @param  {string} tokenPinCode   Пин-код токена, с помощью которого подписывается текст задания
     * @return {Deferred<WebAccess.agent.edms>} Объект типа edms.
     * @see https://api.jquery.com/category/deferred-object/
     */
    signJob: function (jobId, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback, pluginVersion, tokenPinCode) {
      var me = this;
      var d = $.Deferred();
      RequestToken(TOKEN_OPERATION.SIGN_TASK | TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
        var requestParams = {
          "JobID": jobId,
          "Token": token,
          "PluginVersion": typeof pluginVersion == 'undefined' ? null : pluginVersion,
          "TokenPinCode": typeof tokenPinCode == 'undefined' || tokenPinCode == null ? "" : tokenPinCode
        };
        me._signObject("SignJobText", requestParams, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback)
          .done(function (res) {
            d.resolve(res);
          }).fail(function (res) {
          d.reject(res);
        });
      }, jobId);
      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Подписывает текст задачи.
     *
     * @method WebAccess.agent.edms.signTask
     * @param  {number} taskID             ИД задачи для подписания
     * @param  {number} certificateID      ИД сертификата, которым будет подписываться текст задачи
     * @param  {string} pluginName      Имя плагина Агента веб-доступа для подписания
     * @param  {string} comment            Комментарий к подписи
     * @param  {boolean} isApprovingSign    Признак утверждающей подписи
     * @param  {boolean} isForSubstitute    Признак подписания текста от имени замещаемого пользователя
     * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
     * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {string} pluginVersion   Версия плагина Агента веб-доступа для подписания
     * @param  {string} tokenPinCode   Пин-код токена, с помощью которого подписывается текст задачи
     * @return {Deferred<WebAccess.agent.edms>} Объект типа edms.
     * @see https://api.jquery.com/category/deferred-object/
     */
    signTask: function (taskID, certificateID, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback, pluginVersion, tokenPinCode) {
      var me = this;
      var d = $.Deferred();
      RequestToken(TOKEN_OPERATION.SIGN_TASK | TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
        var requestParams = {
          "TaskID": taskID,
          "Token": token,
          "PluginVersion": typeof pluginVersion == 'undefined' ? null : pluginVersion,
          "TokenPinCode": typeof tokenPinCode == 'undefined' || tokenPinCode == null ? "" : tokenPinCode
        };
        me._signObject("SignTaskText", requestParams, certificateID, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback)
          .done(function (res) {
            d.resolve(res);
          }).fail(function (res) {
          d.reject(res);
        });
      }, taskID);
      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Подписать произвольный объект.
     *
     * @method WebAccess.agent.edms._signObject
     * @param  {string} requestName        Название запроса
     * @param  {Object} requestParams      Объект с параметрами для запроса
     * @param  {string} certificateId      Ид сертификата
     * @param  {string} pluginName         Имя плагина подписания в Base64
     * @param  {string} comment            Комментарий к подписи
     * @param  {boolean} isApprovingSign    Признак утверждающей подписи
     * @param  {boolean} isForSubstitute    Признак если подпись совершается от имени замещаемого пользователя
     * @param  {string} substituteUserCode Если isForSubstitute = true, то здесь передается код замещаемого пользователя
     * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
     * @private
     * @return {Deferred<Object>} Результат подписания
     * @see https://api.jquery.com/category/deferred-object/
     */
    _signObject: function (requestName, requestParams, certificateId, pluginName, comment, isApprovingSign, isForSubstitute, substituteUserCode, onSignedCallback) {
      var d = $.Deferred();
      requestParams["PluginName"] = pluginName;
      requestParams["CertificateID"] = certificateId;
      requestParams["Comment"] = !!comment ? encodeURIComponent(comment) : "";
      requestParams["IsApprovingSign"] = !!isApprovingSign ? isApprovingSign : false;
      requestParams["IsForSubstitute"] = !!isForSubstitute ? isForSubstitute : false;
      requestParams["SubstituteUserCode"] = !!substituteUserCode ? substituteUserCode : "";

      global.transmitRequest(requestName, "edmsplugin", requestParams).always(function (res) {
        if (onSignedCallback) onSignedCallback(res);
      }).done(function (res) {
        d.resolve(res);
      }).fail(function (res) {
        d.reject(res);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает ключ для дешифрования документа.
     *
     * @method WebAccess.agent.edms.getDocumentDecryptedKey
     * @param  {int} documentID            ИД документа
     * @param  {string} encryptionType     Тип шифрования
     * @param  {base64string} pluginName   Имя плагина Агента веб-доступа для шифрования
     * @param  {string} password           Пароль для расшифровки
     * @param  {function} onSuccess        Функция обратного вызова для возвращения ключа. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {function} onError          Функция обратного вызова для отображения ошибки. В качестве параметра передается ответ от Агента веб-доступа
     * @return {WebAccess.agent.edms} Объект типа edms.
     */
    getDocumentDecryptedKey: function (documentID, encryptionType, pluginName, password, onSuccess, onError) {
      var me = this;
      RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
        var requestParams = { "DocID": documentID, "Version": 0, "Token": token };
        return me._getObjectDecryptedKey("GetDocDecryptedKey", requestParams, encryptionType, pluginName, password, onSuccess, onError);
      }, documentID, 0);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает ключ для дешифрования задачи.
     *
     * @method WebAccess.agent.edms.getTaskDecryptedKey
     * @param  {int} documentID            ИД задачи
     * @param  {string} encryptionType     Тип шифрования
     * @param  {base64string} pluginName   Имя плагина Агента веб-доступа для шифрования
     * @param  {string} password           Пароль для расшифровки
     * @param  {function} onSuccess        Функция обратного вызова для возвращения ключа. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {function} onError          Функция обратного вызова для отображения ошибки. В качестве параметра передается ответ от Агента веб-доступа
     * @return {WebAccess.agent.edms} Объект типа edms.
     */
    getTaskDecryptedKey: function (taskID, encryptionType, pluginName, password, onSuccess, onError) {
      var me = this;
      RequestToken(TOKEN_OPERATION.GET_ENCRYPTION_KEY, function (token) {
        var requestParams = { "TaskID": taskID, "Token": token };
        return me._getObjectDecryptedKey("GetTaskDecryptedKey", requestParams, encryptionType, pluginName, password, onSuccess, onError);
      }, taskID);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает ключ для дешифрования задания.
     *
     * @method WebAccess.agent.edms.getJobDecryptedKey
     * @param  {int} jobID                 ИД задания
     * @param  {string} encryptionType     Тип шифрования
     * @param  {base64string} pluginName   Имя плагина Агента веб-доступа для шифрования
     * @param  {string} password           Пароль для расшифровки
     * @param  {function} onSuccess        Функция обратного вызова для возвращения ключа. В качестве параметра передается ответ от Агента веб-доступа
     * @param  {function} onError          Функция обратного вызова для отображения ошибки. В качестве параметра передается ответ от Агента веб-доступа
     * @return {WebAccess.agent.edms} Объект типа edms.
     */
    getJobDecryptedKey: function (jobID, encryptionType, pluginName, password, onSuccess, onError) {
      var me = this;
      RequestToken(TOKEN_OPERATION.GET_ENCRYPTION_KEY, function (token) {
        var requestParams = { "JobID": jobID, "Token": token };
        return me._getObjectDecryptedKey("GetJobDecryptedKey", requestParams, encryptionType, pluginName, password, onSuccess, onError);
      }, jobID);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить ключ для дешифрования объекта.
     * @method WebAccess.agent.edms._getObjectDecryptedKey
     * @private
     * @param  {string} requestName        Название запроса
     * @param  {object} requestParams      Объект с параметрами для запроса
     * @param  {string} encryptionType     Тип шифрования
     * @param  {base64string} pluginName   Имя плагина шифрования
     * @param  {string} password           Пароль для расшифровки
     * @param  {function} onSuccess        Функция обратного вызова для возвращения ключа. В качестве параметра передается ответ от агента.
     * @param  {function} onError          Функция обратного вызова для отображения ошибки. В качестве параметра передается ответ от агента.
     */
    _getObjectDecryptedKey: function (requestName, requestParams, encryptionType, pluginName, password, onSuccess, onError) {
      requestParams["EncryptionPluginName"] = pluginName;
      requestParams["EncodeType"] = encryptionType;
      requestParams["Password"] = password;

      global.transmitRequest(requestName, "edmsplugin", requestParams).done(function (response) {
        if (onSuccess) { onSuccess(response.result); }
      }).fail(function (response) {
        if (onError) onError(response.message);
      });
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.edms = edms;
})(window.WebAccess.agent);
